import React, { useEffect, useState } from "react";
import "./input.css";
import "./checkbox.css";
import { Data, SetState } from "../../lib/typeDeclarations";

type TextInputProps = {
  label?: string;
  placeholder?: string;
  name: string;
  value: { [key: string]: string | boolean };
  setValue: SetState;
  pattern?: string;
  required?: boolean;
  readonly?: boolean;
  error?: string;
};

export default function CheckBox({ label, placeholder, name, value, setValue, required, readonly, error }: TextInputProps) {
  const handleClick = () => {
    if (value[name]) {
      setValue({ ...value, [name]: 0 });
    } else {
      setValue({ ...value, [name]: 1 });
    }
  };

  return (
    <div className="checkbox-wrapper">
      <input type="checkbox" checked={!!value[name]} onChange={handleClick} id={name.toString()} />
      <label className="cbx" htmlFor={name.toString()}>
        {label}
      </label>
    </div>
  );
}
